import { render } from "./EditGruposDeUsuarios.vue?vue&type=template&id=e60ea280"
import script from "./EditGruposDeUsuarios.vue?vue&type=script&lang=js"
export * from "./EditGruposDeUsuarios.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__